import { render, staticRenderFns } from "./PackageAndTagModal.vue?vue&type=template&id=07efd6ea&scoped=true"
import script from "./PackageAndTagModal.vue?vue&type=script&lang=js"
export * from "./PackageAndTagModal.vue?vue&type=script&lang=js"
import style0 from "./PackageAndTagModal.vue?vue&type=style&index=0&id=07efd6ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07efd6ea",
  null
  
)

export default component.exports